// Vendor imports
const _ = require('lodash')

// Action types

const HIDE = 'CONFIRM_MODAL_HIDE'
const SHOW = 'CONFIRM_MODAL_SHOW'

// Action creators

function hide() {
  return {
    type: HIDE
  }
}

function alert(options) {
  const buttons = [
    { label: 'OK', modifiers: 'primary' }
  ]
  if (_.isString(options)) {
    return show({ buttons, subheading: options })
  }
  if (_.isError(options)) {
    const heading = options.friendlyHeading || 'Sorry.'
    const subheading = options.friendlyMessage || 'Something went wrong. Try again.'
    return show({ buttons, heading, subheading })
  }
  return show({ buttons, ...options })
}

function confirm(options) {
  const buttons = [
    { label: 'Yes', value: true, modifiers: 'primary' },
    { label: 'No', value: false }
  ]
  if (_.isString(options)) {
    return show({ buttons, subheading: options })
  }
  return show({ buttons, ...options })
}

// Action dispatchers

function show(options) {
  return function (dispatch) {
    return new Promise(resolve => {
      dispatch({
        type: SHOW,
        payload: {
          ...options,
          onConfirm: value => {
            dispatch(hide())
            resolve(value)
          }
        }
      })
    })
  }
}

// Exports

module.exports = {
  HIDE,
  SHOW,
  alert,
  confirm,
  hide,
  show
}
